export const featuredPortfolio = [
    {
      id: 1,
      title: "My Portfolio",
      img:
        "assets/PortfolioProject.png",
      link: "https://arsen-moroz-portfolio.netlify.app/"
    },
    {
      id: 2,
      title: "NFT Project",
      img: "assets/NFTProject.png",
      link: "https://bearbrick-art.netlify.app",
    },
    {
      id: 3,
      title: "Comming Soon",
      img:
        "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
      link: "#"
      },
    {
      id: 4,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/4095861/screenshots/15467417/media/d6a15c416626f12b31fa5ca1db192572.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 5,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 6,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
      link: "#"
    },
  ];
  
  export const webPortfolio = [
    {
      id: 7,
      title: "Planning",
      img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 8,
      title: "Planning",
      img: "https://cdn.dribbble.com/users/3967258/screenshots/15463803/media/4fddb9a2caf3b3bd634060f706a91e73.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 9,
      title: "Planning",
      img: "https://cdn.dribbble.com/users/3637068/screenshots/15467010/media/69a3279182b75365013fe285733d1122.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 10,
      title: "Planning",
      img: "https://cdn.dribbble.com/users/2264844/screenshots/15463998/media/d85e92a332c41094f68e1f716884f7ce.jpg?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 11,
      title: "Planning",
      img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 12,
      title: "Planning",
      img: "https://cdn.dribbble.com/users/2264844/screenshots/15463998/media/d85e92a332c41094f68e1f716884f7ce.jpg?compress=1&resize=1200x900",
      link: "#"
     },
  ];
  
  export const mobilePortfolio = [
    {
      id: 13,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 14,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
      link: "#"
     },
    {
      id: 15,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 16,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 17,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/26642/screenshots/15462545/media/1a202ef5c8338b6f78634e6edc1ba350.png?compress=1&resize=1200x900",
      link: "#"
    },
    {
      id: 18,
      title: "Planning",
      img:
        "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
      link: "#"
    },
  ];
  
  